const DracoParamSalesRequest = {    
    pageDesc: `- 업무요청서를 등록 하는 화면 입니다.
- 업무요청서 종류를 선택 할 수 있으며 현재 'RTU 설치 요청서' 만 등록 가능 합니다.
- 사업 프로젝트 및 명칭, 현장명, 납기일자, 업무내용, 모델 등 업무요청시 필요한 여러 정보를 입력 가능 합니다.
- 필요 서류들을 첨부 할 수 있습니다.
- 업무요청서 등록시 각 담당자에게 이메일이 발송 됩니다.`,

    fewShot: `요청내용: 2025년도 한국에너지공단 eTU25-BD 프로젝트로 신재생융복합사업모니터링 설치 요청입니다.
현장명은 "서울 강남구 테헤란로 100", 납기일자는 2025년 5월 10일입니다.
eTU-0316 모델 사용하며, eTU 셋팅과 수용가 등록도 필요합니다.
요청사항은 "설치 전 사전 연락 바랍니다".

응답내용: 
{  
  "command":[
    {"cd":"SC", "id":"pjtSeq", "val":"96", "custom":""},
    {"cd":"SC", "id":"rtuBizDivCd", "val":"001", "custom":""},
    {"cd":"IW", "id":"spotNm", "val":"서울 강남구 테헤란로 100", "custom":""},
    {"cd":"IW", "id":"ddateDay", "val":"2025-05-10", "custom":""},
    {"cd":"SC", "id":"prdtSeq", "val":"001", "custom":""},
    {"cd":"CA", "id":"rtuSetYn", "val":"", "custom":""},
    {"cd":"CA", "id":"siteRegYn", "val":"", "custom":""},
    {"cd":"IW", "id":"regInfCntt", "val":"설치 전 사전 연락 바랍니다", "custom":""}
  ]  
}`,
    tags:[
    {
        name: "프로젝트",
        type: "Select",
        id: "pjtSeq",
        items: "",
        getItemsVector: "Y",
        custom:"",
        desc:`다음은 프로젝트 관련 목록 입니다. 각 항목은 다음과 같은 필드를 포함합니다:
- Value: 일련번호
- 사업년도: 사업이 수행된 연도
- 사업주체: 사업을 주관한 기관
- 프로젝트명: 프로젝트 명칭
- 사업구분: 사업의 성격`            
    },
    {
        name: "사업명",
        type: "Select", 
        id: "rtuBizDivCd", 
        items: `Value:001, 사업명:신재생융복합사업모니터링 eTU 설치
Value:002, 사업명:물지원사업모니터링 eTU 설치
Value:003, 사업명:신재생에너지확대기반조성사업 모니터링 eTU 설치
Value:004, 사업명:임대주택단지 모니터링 eTU 설치
Value:005, 사업명:대주택단지(주택지원) 모니터링 eTU 설치
Value:006, 사업명:공공기관태양광 모니터링 eTU 설치
Value:007, 사업명:에너지효율시장조성사업(EER) eTU 납품`,
        getItemsVector: "N",
        custom:"",
        desc:"항목설명: eTU 설치 관련 사업정보를 선택 합니다."
    },
    {
        name: "현장명",
        type: "Input", 
        id: "spotNm", 
        items: "",
        getItemsVector: "N",
        custom:"",
        desc:"항목설명: 설치 현장명을 입력 합니다."
    },
    {
        name: "납기일자",
        type: "Input", 
        id: "ddateDay", 
        items: "",
        getItemsVector: "N",
        custom:"",
        desc:"항목설명: 제품을 납품 해야 하는 일자를 입력 합니다. 입력 형식은 YYYY-MM-DD 입니다."
    },
    {
        name: "업무내용",
        type: "Select", 
        id: "rtuWorkDivCd", 
        items: `Value:001, 업무내용:eTU 셋팅 / 배송
Value:002, 업무내용:eTU 셋팅 / 설치
Value:003, 업무내용:기타업무`,
        getItemsVector: "N",
        custom:"",
        desc:"항목설명: 진행해야할 업무 정보를 선택 합니다."
    },
    {
        name: "eTU 모델",
        type: "Select", 
        id: "prdtSeq", 
        items: `Value:001, eTU모델:eTU-0316
Value:002, eTU모델:eTU-0530
Value:003, eTU모델:eTU-0422`,
        getItemsVector: "N",
        custom:"",
        desc:"항목설명: eTU 모델 정보를 선택 합니다."
    },
    {
        name: "eTU 셋팅",
        type: "Check", 
        id: "rtuSetYn", 
        items: "",
        getItemsVector: "N",
        custom:"",
        desc:"항목설명: eTU 제품의 설정이 필요한지 여부를 선택 합니다."
    },
    {
        name: "수용가 등록",
        type: "Check", 
        id: "siteRegYn", 
        items: "",
        getItemsVector: "N",
        custom:"",
        desc:"항목설명: 수용가를 등록 해야 하는지 여부를 선택 합니다."
    },
    {
        name: "LoRa 등록",
        type: "Check", 
        id: "loraRegYn", 
        items: "",
        getItemsVector: "N",
        custom:"",
        desc:"항목설명: LoRa 정보를 등록 해야 하는지 여부를 선택 합니다."
    },
    {
        name: "설비등록",
        type: "Check", 
        id: "facRegYn", 
        items: "",
        getItemsVector: "N",
        custom:"",
        desc:"항목설명: 설비정보를 등록 해야 하는지 여부를 선택 합니다."
    },
    {
        name: "하이박스 구성",
        type: "Check", 
        id: "boxComposiYn", 
        items: "",
        getItemsVector: "N",
        custom:"",
        desc:"항목설명: 하이박스가 구성 되는지 여부를 선택 합니다."
    },
    {
        name: "명판제작",
        type: "Check", 
        id: "npComposiYn", 
        items: "",
        getItemsVector: "N",
        custom:"",
        desc:"항목설명: 명판제작을 진행 하는지 여부를 선택 합니다."
    },
    {
        name: "배송",
        type: "Check", 
        id: "dlvrYn", 
        items: "",
        getItemsVector: "N",
        custom:"",
        desc:"항목설명: 배송을 진행 하는지여부를 선택 합니다."
    },
    {
        name: "현장설치",
        type: "Check", 
        id: "spotInstlYn", 
        items: "",
        getItemsVector: "N",
        custom:"",
        desc:"항목설명: 현장설치를 진행 하는지 여부를 선택 합니다."
    },
    {
        name: "음성송출",
        type: "Check", 
        id: "voicSendYn", 
        items: "",
        getItemsVector: "N",
        custom:"",
        desc:"항목설명: 음성송출을 사용 하는지 여부를 선택 합니다."
    },
    {
        name: "요청사항",
        type: "Input", 
        id: "regInfCntt", 
        items: "",
        getItemsVector: "Y",
        custom:"",
        desc:"항목설명: 요청사항 내용을 입력 합니다."
    },
    {
        name: "필요사항",
        type: "Input", 
        id: "ncstMtrCntt", 
        items: "",
        getItemsVector: "N",
        custom:"",
        desc:"항목설명: 필요한 사항 정보를 입력 합니다."
    },
    {
        name: "필요일자",
        type: "Input", 
        id: "ncstMtrDate", 
        items: "",
        getItemsVector: "N",
        custom:"",
        desc:"항목설명: 필요한 사항에 대한 일자를 입력 합니다. 입력 형식은 YYYY-MM-DD 입니다."
    },
    {
        name: "처리결과",
        type: "Input", 
        id: "procRsltCntt", 
        items: "",
        getItemsVector: "N",
        custom:"",
        desc:"항목설명: 처리결과에 대한 내용을 입력 합니다."
    },
    {
        name: "처리일자",
        type: "Input", 
        id: "procRsltDate", 
        items: "",
        getItemsVector: "N",
        custom:"",
        desc:"항목설명: 처리 결과에 대한 일자를 입력 합니다. 입력 형식은 YYYY-MM-DD 입니다."
    },
    {
        name: "저장 버튼",
        type: "Button", 
        id: "save", 
        items: "",
        getItemsVector: "N",
        custom:"",
        desc:"항목설명: 업무요청서를 저장 합니다."
    },
    {
        name: "목록 버튼",
        type: "Button", 
        id: "list", 
        items: "",
        getItemsVector: "N",
        custom:"",
        desc:"항목설명: 목록 화면으로 이동 합니다."
    }]
}


export default DracoParamSalesRequest;